import React from "react";
import DateTimeComponent from "./DateTime";

class DateTimeEditor extends React.Component{
    constructor(props){
        super(props);
        this.dateTime = null;
        this.inputRef = React.createRef();
    }

    getValue = () => {
        return this.dateTime;
    }

    isPopup = () => {
        return true;
    }

    handleUpdate = (value) => {
        this.dateTime = value;
        this.focusInput();
        if(this.props.onChange){
            this.props.onChange(value);
        }
    }

    afterGuiAttached(){
        this.focusInput();
    }

    focusInput = () =>{
        if(!this.props.disableFocus && this.inputRef && this.inputRef.current && this.inputRef.current.inputElement){
            this.inputRef.current.inputElement.focus();
        }
    }

    render(){
        return(
           <DateTimeComponent  {...this.props} onChange={this.handleUpdate} inputRef={this.inputRef} focusInput={this.focusInput}/>
        )
    }


}

export default DateTimeEditor;